import { Record, Map as ImmutableMap } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
import { AnchorDelayDirectionType } from 'automation-ui-action-features/actions/classic-anchored-delay/constants/AnchorDelayDirectionType';
import * as ClassicAnchoredDelayActionMetadataKeys from 'automation-ui-action-features/actions/classic-anchored-delay/constants/ClassicAnchoredDelayActionMetadataKeys';
export default class ClassicAnchoredDelayActionMetadata extends Record({
  [ClassicAnchoredDelayActionMetadataKeys.ACTION_TYPE]: ActionTypes.CLASSIC_ANCHORED_DELAY,
  [ClassicAnchoredDelayActionMetadataKeys.DELAY]: null,
  [ClassicAnchoredDelayActionMetadataKeys.DIRECTION]: AnchorDelayDirectionType.AFTER
}, 'ClassicAnchoredDelayActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const delay = propMap.get(ClassicAnchoredDelayActionMetadataKeys.DELAY);
    super(propMap.set(ClassicAnchoredDelayActionMetadataKeys.DELAY, new TimeDelay(delay)));
  }
}